import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { X, BookOpen, ArrowRight } from "lucide-react";
import { utopistasArticulos } from "@/data/utopistasArticulos";
import { UtopistasMark } from "./UtopistasLogo";

const KEY = "utop_nota_popup";

export const UtopistasNotaPopup = () => {
  const [show, setShow] = useState(false);
  const { pathname } = useLocation();
  const visible = pathname.startsWith("/marca") && !pathname.startsWith("/marca/blog");
  const a = utopistasArticulos[0];

  useEffect(() => {
    if (!visible || sessionStorage.getItem(KEY)) return;
    const t = setTimeout(() => setShow(true), 6000);
    return () => clearTimeout(t);
  }, [visible]);

  const close = () => { setShow(false); sessionStorage.setItem(KEY, "1"); };

  return (
    <AnimatePresence>
      {show && visible && (
        <motion.div initial={{ opacity: 0, y: 60, scale: 0.96 }} animate={{ opacity: 1, y: 0, scale: 1 }} exit={{ opacity: 0, y: 40 }} transition={{ type: "spring", stiffness: 220, damping: 24 }}
          className="fixed z-[60] inset-x-4 bottom-24 md:inset-x-auto md:left-8 md:bottom-8 md:w-[460px] font-utopbody" role="dialog" aria-label="Nueva nota en el blog Utopistas" data-testid="utopistas-nota-popup">
          <div className="relative overflow-hidden rounded-[2rem] bg-utop-hueso text-utop-azul shadow-[0_30px_80px_-20px_rgba(12,57,91,0.5)] border-2 border-utop-beige">
            <div className="absolute inset-0 utop-pattern opacity-[0.08]" aria-hidden="true" />
            <button onClick={close} aria-label="Cerrar" data-testid="utopistas-nota-close" className="absolute top-4 right-4 z-10 h-12 w-12 rounded-full bg-white text-utop-azul shadow flex items-center justify-center hover:bg-utop-rojo hover:text-white transition"><X size={24} /></button>
            <div className="relative grid grid-cols-5">
              <div className="col-span-2 relative min-h-[220px]">
                <img src={a.portada} alt={a.titulo} className="absolute inset-0 w-full h-full object-cover grayscale" />
                <motion.div initial={{ scale: 0, rotate: -20 }} animate={{ scale: 1, rotate: -8 }} transition={{ delay: 0.4, type: "spring" }} className="absolute -bottom-3 -right-5 bg-utop-mostaza text-utop-azul font-utop text-2xl px-4 py-2 rounded-2xl shadow-lg border-2 border-white">¡Nueva nota!</motion.div>
              </div>
              <div className="col-span-3 p-6 pt-7">
                <div className="flex items-center gap-2 mb-3"><UtopistasMark size={34} /><span className="font-utophand text-utop-rojo text-lg">Blog Utopistas</span></div>
                <h3 className="font-utop text-4xl leading-[0.9] mb-3">{a.titulo}</h3>
                <p className="text-lg text-utop-azul/80 leading-snug line-clamp-3 mb-5">{a.resumen}</p>
                <div className="flex flex-col gap-2">
                  <Link to={`/marca/blog/${a.slug}`} onClick={close} data-testid="utopistas-nota-leer" className="inline-flex items-center justify-center gap-2 bg-utop-azul text-white px-6 py-4 rounded-full text-lg font-semibold hover:bg-utop-rojo transition"><BookOpen size={20} /> Leer la nota</Link>
                  <Link to="/marca/blog" onClick={close} data-testid="utopistas-nota-todas" className="inline-flex items-center justify-center gap-2 text-utop-azul text-lg font-semibold hover:text-utop-rojo transition">Ver todas las notas <ArrowRight size={18} /></Link>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
